import { ErrorNotification } from 'components/Notification';
import { WrapStrong } from 'components/WrapStrong';
import React, { FC } from 'react';
import { translationKeys, useTranslation } from 'services/localization';
import { ActionNotificationMessageProps } from '../../types';

const ErrorRequest: FC<ActionNotificationMessageProps> = () => {
  const { translate } = useTranslation();

  return (
    <ErrorNotification title={translate(translationKeys.NOTIFICATION_ERROR_MESSAGE_TITLE)}>
      <p>
        <WrapStrong value={translate(translationKeys.NOTIFICATION_ERROR_MESSAGE_DESCRIPTION)} start={-4} />
      </p>
    </ErrorNotification>
  );
};

export default ErrorRequest;
